export default "__VITE_ASSET__DZKJAKEM__"